<template>
  <div class="master-page">
    <div class="clearfix">
      <levelbar></levelbar>
    </div>
    <div class="main-container" :style="{minHeight: contentHeight}">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  import levelbar from './levelbar'
  export default {
    name: 'masterPage',
    components: {
      levelbar
    },
    data() {
      return {
        contentHeight: ''
      }
    },
    created() {
      if (document.documentElement.clientHeight) {
        this.contentHeight = document.documentElement.clientHeight-124 + 'px';
      } else {
        this.contentHeight = document.body.clientHeight-124 + 'px';
      }
    }
  }
</script>
<style lang="less" scoped>
  @base-bg: #00a0e9;
  .master-page {
    background-color: #ececec;
    padding: 0 10px;
    min-height: 100%;

    .main-container {
      background-color: #fff;
      border: 1px solid #e0e0e0;
      padding: 16px 24px 24px;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/masterPage.vue